import { api } from "../api";

const BASE_URL = "account";

export const login = async (data) => {
  return api.post(`${BASE_URL}/login`, data).then((res) => {
    localStorage.setItem("jwt_token", res.accessToken);
  });
};
